import {useEffect, useState} from 'react';
import {debounce} from 'lodash-es';
import cx from 'classnames';
import styles from './index.module.scss';
import classNames from 'classnames';

export function LoadingIcon({className}: {className?: string}) {
    return (
        <div className={cx(styles.loadingIcon, className)} />
    );
}

export function StatusLoading({className, text, delay = 0}: {className?: string, text?: string, delay?: number}) {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const updateLoading = debounce<() => void>(() => {
            setLoading(true);
        }, delay);
        updateLoading();
        return () => {
            updateLoading?.cancel?.();
        };
    }, [delay]);

    return loading ? (
        <div className={cx(styles.statusWrap, className)}>
            <LoadingIcon />
            <div className={styles.statusText}>{text || '加载中...'}</div>
        </div>
    ) : null;
}

export function StatusError({className, text, retryText, onRetry}: {
    className?: string;
    text?: string;
    retryText?: string;
    onRetry: () => void;
}) {
    return (
        <div className={cx(styles.statusWrap, className)}>
            <div className={styles.retryIcon} />
            <div className={styles.statusText}>
                <span>{text || '加载失败'}&nbsp;&nbsp;</span>
                <span style={{color: '#3377FF', cursor: 'pointer'}} onClick={onRetry}>{retryText || '重新加载'}</span>
            </div>
        </div>
    );
}

export function NoPermission({className, text}: {className?: string, text?: string}) {
    return (
        <div className={cx(styles.statusWrap, className)}>
            <div className={styles.errorIcon} />
            <div className={styles.statusText}>{text || '您暂无权限'}</div>
        </div>
    );
}

export function NoData({className, text}: {className?: string, text?: string}) {
    return (
        <div className={cx(styles.statusWrap, className)}>
            <div className={styles.searchNoDataIcon} />
            <div className={styles.statusText}>{text || '暂无数据'}</div>
        </div>
    );
}

export function MoveCopySearchNoData({className, text}: {className?: string, text?: string}) {
    return (
        <div className={cx(styles.statusWrap, className)}>
            <div className={classNames(styles.searchNoDataIcon, styles.searchNoDataImg)} />
            <div className={classNames(styles.statusText, styles.noDataText)}>{text || '暂无数据'}</div>
        </div>
    );
}

export function SearchNoData({className, text}: {className?: string, text?: string}) {
    return (
        <div className={cx(styles.statusWrap, className)}>
            <div className={styles.searchNoDataIcon} />
            <div className={styles.statusText}>{text || '未找到相关结果'}</div>
        </div>
    );
}
